<article class="service-option">
  <div class="service-option-copy">
    <strong class="service-option-title">{{ displayName }}</strong>

    <div *ngIf="categories.length" class="service-categories" aria-label="Categoria do serviço">
      <span *ngFor="let category of categories">{{ category }}</span>
    </div>

    <div *ngIf="locationLabel" class="service-location">
      <mat-icon aria-hidden="true">place</mat-icon>
      <span>{{ locationLabel }}</span>
    </div>

    <div class="service-payment-line">
      <mat-icon aria-hidden="true">payments</mat-icon>
      <span>{{ privatePriceLabel }}</span>
    </div>

    <div class="service-payment-line service-coverage">
      <mat-icon aria-hidden="true">health_and_safety</mat-icon>
      <span>{{ coverageLabel }}</span>
    </div>

    <div *ngIf="providers.length" class="service-providers">
      <span class="service-providers-label">Profissionais:</span>
      <span *ngFor="let provider of providers; let last = last">
        {{ provider }}<span *ngIf="!last">, </span>
      </span>
    </div>
  </div>

  <button type="button" mat-stroked-button color="primary" class="service-schedule-button" (click)="schedule.emit()">
    <mat-icon aria-hidden="true">calendar_month</mat-icon>
    {{ scheduleLabel }}
  </button>
</article>
